export default {
  TYPES: [
    { KEY: 'total', VALUE: 'Total' },
    { KEY: 'discriminated', VALUE: 'Discriminado' },
  ],
};
